export default __webpack_public_path__ + "static/media/boo-neutral.e04abdc5.png";